import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { applyInitiativesSearchCriteria, clearInitiativesSearchCriteria } from "domains/initiatives/actions";
import { getInitiativesSearchCriteria } from "domains/initiatives/selectors";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicInitiativeFilterModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const searchCriteria = useSelector(getInitiativesSearchCriteria);
  const filters = useSelector(getTopicFilters("initiatives"));

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyInitiativesSearchCriteria(payload))}
      handleClear={() => dispatch(clearInitiativesSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.initiatives.filter.title")}
    />
  );
};
